module.exports = __webpack_public_path__ + "static/media/Arcade_6721.68e2e0c2.jpg";